module.exports = "pegasus/assets/presentation_bg_2.png";